export default __webpack_public_path__ + "static/media/vanakkam-dsa-logo.4c856fc6.png";